import './App.css';
import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';

import NavBar from './components/layout/NavBar';
import PageHeader from './components/layout/PageHeader';

import EventScreen from './screens/EventScreen';  // Use the dynamic EventScreen
import LoginScreen from './screens/LoginScreen';
import SettingsScreen from './screens/SettingsScreen';
import SiteSwitchScreen from './screens/SiteSwitchScreen';
import ParkingAreaScreen from './screens/ParkingAreaScreen';

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import useAxios from './plugins/useAxios';

const App = () => {
  const [isLogged, setLogged] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Plate Verifier';
    const auth = () => {
      useAxios.get('/auth').then(response => {
        setLogged(true);
        const tagSite = localStorage.getItem('site');
        const direction = localStorage.getItem('direction'); // Assume direction is stored in localStorage

        if (tagSite) {
          // Navigate to the correct EventScreen based on the direction (in or out)
          if (direction) {
            navigate(`/events/${direction}`);
          } else {
            navigate('/events/in');  // Default to 'in' direction
          }
        } else {
          navigate('/sites');
        }
      })
        .catch(err => {
          setLogged(false);
          console.log(err);
          navigate('/login');
        });
    };
    auth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);  // Auth should only run once on mount


  return (
    <div className='flex flex-col lg:flex-row'>
      {isLogged ? (
        <>
          <NavBar setLogged={setLogged} />
          <div className="min-h-screen flex-1 overflow-scroll max-h-screen lg:pt-0 pt-24">
            <PageHeader />
            <Routes>
              <Route index path="/sites" element={<SiteSwitchScreen />} />
              <Route path="/events/:direction" element={<EventScreen />} />
              <Route path="/parking"  element={<ParkingAreaScreen />} />
              <Route path="/settings" element={<SettingsScreen />} />
            </Routes>
          </div>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginScreen setLogged={setLogged} />} />
        </Routes>
      )}
    </div>
  );
};

export default App;
